module.exports = __webpack_public_path__ + "static/facebook-f8a2ae03304bea468fb19af693c717ee.png";